import React from "react";

import cookies from "../utils/cookies";
import { useSearchParams } from "react-router-dom";

const JourneyContext = React.createContext({
  appId: null,
});

/**
 * Allows direct hook access to the journey context
 */
export const useJourneyContext = () => React.useContext(JourneyContext);

/**
 * Custom context provider
 */
export const JourneyContextProvider = ({ children }) => {
    const [queryParams] = useSearchParams();
    // const queryParams = queryString.parse(window.location.search);
    let foundAppId = queryParams.get("appId") || queryParams.get("appid") || queryParams.get("appID")
    if (!foundAppId) {
      const contextCookie = cookies.context.get();
      foundAppId = contextCookie?.appId;
    }
    foundAppId = parseAppId(foundAppId);
    cookies.context.set(JSON.stringify({ appId: foundAppId }));
    JourneyContext.appId = foundAppId;

    return (
        <JourneyContext.Provider value={JourneyContext}>
            {children}
        </JourneyContext.Provider>
    );
};

/**
 * parses idString to check for _
 * @param idString
 * @returns {string}
 */
export function parseAppId(idString) {
    if (idString !== undefined && !idString.includes("_")) {
        idString = `${idString}_`;
    }
    return idString;
}
